import type { Product } from '../models';

export const shouldShowIsDiscontinuedErrorInfo = (products: Product[]) => {
  if (products.length > 0) {
    return products.every((product) => product.isDiscontinuedAndCannotBeSold);
  }

  return false;
};
